import { get, find } from 'lodash';

export const getCurrentProduct = (state, slug) => {
  return state.products.list && find(state.products.list, { slug });
};

export const getCurrentProductEndpoints = (state, slug) => {
  return get(getCurrentProduct(state, slug), 'serviceEndpoints');
};

// @TODO_REMOVE: Remove after Rules Engine update headers validation (now require specific Accept header)
// Find another mentions regarding custom headers
export const getCurrentProductHeaders = (state, slug) => {
  return get(getCurrentProduct(state, slug), 'serviceHeaders');
};
